import script from "./acquaint-text-area.vue?vue&type=script&setup=true&lang=ts"
export * from "./acquaint-text-area.vue?vue&type=script&setup=true&lang=ts"

import "./acquaint-text-area.vue?vue&type=style&index=0&id=bae8377e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bae8377e"]])

export default __exports__